@charset "UTF-8";
.ticket-label-content {
  width: 400px;
  /*
  * Fix temporaire. Permet à la section des cartes de membres de prendre
  * toujours 100% (les autres sections aussi, pour être certain).
  * Fix à supprimer une fois qu'on aura retravaillé le layout et fait en sorte que les 
  * cartes de membres sont une section à part entière (et non pas une sous-section de
  * la sélection du client.
  */
}
.ticket-label-content > * {
  width: 100%;
}
.ticket-label-content .cart-item-label .cart-item {
  min-height: 70px;
  padding: 8px 7px 7px 7px;
  margin: 10px 0;
  border: solid 1px #ccc;
  border-radius: 5px;
  font-weight: bold;
  background-color: #eee;
}
.ticket-label-content .cart-item-label .cart-item .item-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ticket-label-content .selected-ticket-label {
  min-height: 70px;
  padding: 8px 7px 7px 7px;
  margin: 10px 0;
  border: solid 1px #ccc;
  border-radius: 10px;
  font-weight: bold;
  background-color: #fff;
  transition: all 0.3s;
}
.ticket-label-content .selected-ticket-label .ticket-infos {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.ticket-label-content .selected-ticket-label .ticket-infos i {
  margin-left: 10px;
  font-size: 20px;
}
.ticket-label-content .selected-ticket-label .ticket-infos i:hover {
  cursor: pointer;
  filter: brightness(150%);
}
.ticket-label-content .selected-ticket-label .other-info {
  padding-top: 5px;
  width: 98%;
}
.ticket-label-content .selected-ticket-label .link {
  cursor: pointer;
}

@media screen and (min-width: 800px) and (max-width: 1025px) {
  .ticket-label-content {
    margin: auto;
    max-width: 60%;
  }
}
@media screen and (max-width: 800px) {
  .ticket-label-content {
    width: 100%;
  }
}
@media screen and (min-width: 475px) {
  .ticket-main-text {
    max-width: 65%;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */